import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { TaskFileGroupInterface } from './definitions/task-file-group-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface CancelCompletionTaskFileGroupResponse {
  taskFileGroup: {
    cancelCompletion: {
      output: TaskFileGroupInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class CancelCompletionTaskFileGroupService {
  constructor(private apollo: Apollo) {}

  cancelCompletion(
    taskFileGroupId: string,
    mutation: DocumentNode
  ): Observable<FetchResult<CancelCompletionTaskFileGroupResponse>> {
    return this.apollo.mutate<CancelCompletionTaskFileGroupResponse>({
      mutation: mutation,
      variables: {
        id: taskFileGroupId,
      },
    });
  }
}
